import surelincLogo from '../assets/surelinc-logo.png';

export default function AccountDisabledPage() {
  return (
    <div className="auth-page client-auth-page">
      <article className="auth-card account-disabled-card">
        <div className="auth-brand client-auth-brand">
          <img className="client-auth-logo" src={surelincLogo} alt="SURELINC" />
          <div className="auth-brand-subtitle">Readiness Platform</div>
        </div>
        <div className="auth-login-content">
          <h1>Client account disabled</h1>
          <p>
            Access to the SURELINC Readiness Platform is currently disabled for this client.
            Please contact your organization administrator or SURELINC support for assistance.
          </p>
        </div>
      </article>
    </div>
  );
}
